import $ from 'jquery';

const defaults = {
  exclusive: false,
};

const create = (opts) => {
  const config = { ...defaults, ...opts };

  const disableAllTargets = () => {
    Object.values(config.valueTargetMap).forEach((target) => {
      $(target).hide();
    });
  };

  const selectTarget = (value) => {
    const targetSel = config.valueTargetMap[ value ];
    if (!targetSel) {
      return;
    }
    $(targetSel).show();
  };

  const handleInputChange = (evt) => {
    const selectedValue = evt.target.value;
    disableAllTargets();
    selectTarget(selectedValue);
  };

  return $(config.observeContext).on('change', config.observeInputs, handleInputChange);
};

export default {
  create
};



// WEBPACK FOOTER //
// ./modules/radio-group-toggle.js